import 'css-chunksrc/client/pages/projectPage/documentsPage/sideBar/styles.scss';export default {
  "sideBar": "_sideBar_15a4o_1",
  "link": "_link_15a4o_12",
  "active": "_active_15a4o_23",
  "icon": "_icon_15a4o_26"
};